export default __webpack_public_path__ + "static/media/card.142578e1.svg";